import React from "react";
import TerritoryForm from "./TerritoryForm";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";

const CreateTerritory = () => (
  <DashboardLayout>
    <DashboardNavbar />
    <TerritoryForm />
  </DashboardLayout>
);

export default CreateTerritory;
